var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map"},[_c('div',{attrs:{"id":"g-map"}}),_c('img',{staticClass:"location-icon",attrs:{"src":require("../../assets/imgs/location_icon.png"),"alt":""}})])
}]

export { render, staticRenderFns }